import { jsx as _jsx } from "react/jsx-runtime";
import { createUseStyles } from 'react-jss';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
const useStyles = createUseStyles(theme => ({
  list: {
    listStyleType: 'none',
    paddingLeft: 0
  }
}));
/**
 * Answer options for a single choice question.
 */
const AnswersSingleChoice = ({
  answerChoices
}) => {
  const {
    list
  } = useStyles();
  if (!answerChoices.length) {
    return null;
  }
  return _jsx("ul", {
    className: list,
    children: answerChoices.map(answerChoice => _jsx("li", {
      children: _jsx(Box, {
        mt: 2,
        children: _jsx(Typography, {
          color: "dark",
          variant: "body",
          children: answerChoice
        })
      })
    }, answerChoice))
  });
};
export default AnswersSingleChoice;